import { useEffect } from "react";

/**
 * Блокує скрол body лише коли isLocked === true.
 * При знятті блоку відновлює позицію скролу з моменту блокування (замикання).
 * Якщо при false ще й «розблокувати» через parseInt(body.style.top) — при порожньому top
 * виходить scrollTo(0,0) і сторінка стрибає нагору (конфлікт з іншими інстансами хука).
 */
const useBodyScrollLock = (isLocked) => {
  useEffect(() => {
    if (!isLocked) {
      return undefined;
    }

    const scrollY = window.scrollY;
    document.body.style.position = "fixed";
    document.body.style.top = `-${scrollY}px`;
    document.body.style.width = "100%";

    return () => {
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.width = "";
      window.scrollTo(0, scrollY);
    };
  }, [isLocked]);
};

export default useBodyScrollLock;
